import { render, staticRenderFns } from "./on-account-detail.vue?vue&type=template&id=16d308a4&scoped=true&"
import script from "./on-account-detail.vue?vue&type=script&lang=ts&"
export * from "./on-account-detail.vue?vue&type=script&lang=ts&"
import style0 from "./on-account-detail.vue?vue&type=style&index=0&id=16d308a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d308a4",
  null
  
)

export default component.exports